package com.milta.di

import com.milta.core.auth.JsTokenStorage
import com.milta.core.auth.JsOAuthSignInClient
import com.milta.core.auth.OAuthSignInClient
import com.milta.core.auth.TokenStorage
import com.milta.core.cache.JsLocalCacheStore
import com.milta.core.cache.LocalCacheStore
import com.milta.core.connectivity.ConnectivityObserver
import com.milta.core.connectivity.JsConnectivityObserver
import com.milta.core.location.JsLocationProvider
import com.milta.core.location.LocationProvider
import com.milta.core.mode.AppModeStorage
import com.milta.core.mode.JsAppModeStorage
import org.koin.dsl.module

/** Web dashboard bootstrap — mirrors `androidModule` for the (Kotlin/JS) web target. */
val jsModule = module {
    single<TokenStorage> { JsTokenStorage() }
    single<ConnectivityObserver> { JsConnectivityObserver() }
    single<LocalCacheStore> { JsLocalCacheStore() }
    single<OAuthSignInClient> { JsOAuthSignInClient() }
    // AuthRepositoryImpl (authModule) needs AppModeManager -> AppModeStorage transitively, even
    // though the web dashboard doesn't have a Driver/Enterprise mode switch UI (MIL-54, mobile-only).
    single<AppModeStorage> { JsAppModeStorage() }
    // DOM-05 — RouteInProgressScreen (mobile-only) isn't rendered by the web dashboard, but
    // registered here anyway for koinInject() consistency, same precedent as ConnectivityObserver above.
    single<LocationProvider> { JsLocationProvider() }
}
